exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".inputPlaceholder__LoadingField-module___1XIQ5 {\n  width: 100%;\n  height: 38px;\n  background-color: #8a96a1;\n  animation: placeholder-glow__LoadingField-module___lWAdk 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow__LoadingField-module___lWAdk {\n  0% {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n  50% {\n    background-color: rgba(0, 0, 0, 0.3);\n  }\n  100% {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n}\n", ""]);

// Exports
exports.locals = {
	"inputPlaceholder": "inputPlaceholder__LoadingField-module___1XIQ5",
	"placeholder-glow": "placeholder-glow__LoadingField-module___lWAdk"
};